import {
  FrameShape,
  InnerBeam,
  SideWidths,
} from '@cutr/constants/windows/windows-geometry.ts';
import { Group, Rect } from 'react-konva';

import { position } from '../colors';
import { DEFAULT_FRAME_BEAM_WIDTHS } from '../dimensions';
import { InnerGrid } from '../InnerGrid';
import { useKonva } from '../KonvaContext';

type FrameProps = {
  frame: FrameShape;
  x: number;
  y: number;
  innerBeams: InnerBeam[];
  frameBeamWidthsMM?: SideWidths;
};

export const RectangleFrame = ({
  frame,
  x,
  y,
  innerBeams,
  frameBeamWidthsMM = DEFAULT_FRAME_BEAM_WIDTHS,
}: FrameProps) => {
  const { renderStyles } = useKonva();
  if (frame.frameType !== 'rectangle') return null;

  const { widthMM, heightMM } = frame;
  const { top, right, bottom, left } = frameBeamWidthsMM;
  const stroke = renderStyles.frameStrokeWidthMM;

  // Y grows upward on the flipped canvas, so the small-y inset is the bottom.
  return (
    <>
      <Group x={x} y={y}>
        <Rect
          x={0}
          y={0}
          width={widthMM}
          height={heightMM}
          fill={position.frameFill}
          strokeWidth={renderStyles.frameStrokeWidthMM}
          stroke={position.frameStroke}
        />
        <Group
          clip={{
            x: left,
            y: bottom,
            width: widthMM - left - right,
            height: heightMM - top - bottom,
          }}
        >
          <Rect
            x={left + stroke}
            y={bottom + stroke}
            width={widthMM - left - right - stroke * 2}
            height={heightMM - top - bottom - stroke * 2}
            fill={position.glass}
            strokeWidth={renderStyles.frameStrokeWidthMM}
            stroke={position.frameStroke}
          />
          <InnerGrid innerBeams={innerBeams} />
        </Group>
      </Group>
    </>
  );
};
